import React from 'react';
import { useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { t } from '../i18n';
import { useOrder } from '../OrderContext';
import Header from '../components/Header';

const QROrderPage = () => {
  const navigate = useNavigate();
  const { order, resetOrder, updateOrder } = useOrder();

  const qrPayload = React.useMemo(() => {
    const payload = {
      v: 1,
      user: order.user,
      order: {
        mode: order.orderMode,
        productId: order.product?.id ?? null,
        customMix: order.customMix,
      },
    };
    console.log('[QROrderPage] payload:', payload);
    return btoa(JSON.stringify(payload));
  }, [order]);

  const productName = order.product?.name ?? 'Your Drink';

  const handleStartOver = () => {
    // Begin a fresh order but keep the guest's details so they don't have to
    // fill in the intake form again — drop them straight at the menu.
    const user = order.user;
    resetOrder();
    updateOrder({ user });
    navigate('/menu-type');
  };

  return (
    <div className="kiosk-app rush-tech-bg relative flex h-full w-full flex-col overflow-hidden [animation:pageFadeIn_0.35s_ease_both]">
      <div className="noise-overlay" />
      <Header title={t.qrTitle} onBack={() => navigate(-1)} />

      <div className="relative z-10 flex flex-1 flex-col items-center justify-center gap-5 overflow-y-auto px-4 py-6 sm:gap-6 sm:px-5">
        {/* Order summary — high-contrast chip so the drink name is easy to read */}
        <div className="flex max-w-[88%] flex-col items-center gap-1.5 rounded-[16px] border border-[var(--border-act)] bg-[var(--accent-pressed-bg)] px-5 py-3 text-center shadow-[0_0_22px_var(--accent-pressed-shadow)]">
          <span className="text-[0.7rem] font-semibold uppercase tracking-[0.2em] text-[var(--gold-lt)]">
            {t.qrOrderLabel}
          </span>
          <span className="font-display text-[clamp(1.25rem,5vw,1.7rem)] font-bold leading-tight text-[var(--cream)]">
            {productName}
          </span>
        </div>

        {/* QR code card */}
        <div className="flex flex-col items-center gap-5 rounded-[24px] border border-[var(--border)] bg-white p-5 shadow-[var(--card-shadow)] sm:p-8">
          <QRCodeSVG
            value={qrPayload}
            size={560}
            level="L"
            includeMargin
            style={{ width: 'min(88vw, 560px)', height: 'auto' }}
          />
          <p className="max-w-[280px] text-center text-[0.82rem] leading-snug text-[#334155]">
            {t.qrInstruction}
          </p>
        </div>

        {/* After pour → optional feedback, then start over */}
        <div className="mt-2 flex w-full max-w-sm flex-col gap-3">
          <button
            type="button"
            onClick={() => navigate('/survey')}
            className="touch-target w-full rounded-[16px] border-2 border-[var(--confirm-border)] bg-[var(--confirm-bg)] px-8 py-3.5 font-display text-[0.95rem] font-bold uppercase tracking-[0.12em] text-white shadow-[0_0_18px_var(--confirm-shadow)] transition-opacity active:opacity-80"
          >
            {t.qrRateDrink}
          </button>
          <button
            type="button"
            onClick={handleStartOver}
            className="touch-target w-full rounded-[14px] border border-[var(--border)] bg-[var(--card)] px-8 py-3.5 text-[0.9rem] font-semibold text-[var(--muted-lt)] transition-opacity active:opacity-60"
          >
            {t.qrStartOver}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QROrderPage;
